// extracted by mini-css-extract-plugin
module.exports = {"pill":"e_gS","cart":"e_hS","label":"e_iS","arrow":"e_jS"};